import { GetEventsResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useEvents = (tripId: string | undefined) => {
	return useQuery<GetEventsResponse>({
		queryKey: queryKeys.events(tripId),
		queryFn: async () => {
			if (!tripId) {
				throw new Error('Trip ID is required')
			}
			const response = await api.get<GetEventsResponse>(`/trips/${tripId}/events`)
			return response.data
		},
		enabled: !!tripId, // Only run query if tripId is provided
		retry: 1,
	})
}
